import React from 'react';
import Styles from './position-details.scss';
import { ButtonKVBase, CustomBootstrapTable } from '@/presentation/components';
import { parseNumberMoney, parsePercent } from '@/presentation/utils/number-utils';
import { IconActivity } from '@/presentation/components/icons';
import useValidateUserActivity from '@/presentation/hooks/use-validate-user-activity';
const columnStyle = { overflowWrap: 'break-word', fontSize: 13, fontWeight: 400 };
const headerStyle = { fontSize: 14, fontWeight: 500 };
const columns = [
    {
        dataField: 'name',
        text: 'Name',
        headerStyle: Object.assign({ width: '25%' }, headerStyle),
        style: columnStyle,
        sort: true
    },
    {
        dataField: 'change',
        text: 'Change',
        headerStyle: Object.assign({ width: '25%' }, headerStyle),
        style: columnStyle,
        sort: true
    },
    {
        dataField: 'price',
        text: 'Price',
        headerStyle: Object.assign({ width: '25%' }, headerStyle),
        style: columnStyle,
        sort: true
    },
    {
        dataField: 'marketValue',
        text: 'Market Value',
        headerStyle: Object.assign({ width: '25%' }, headerStyle),
        style: columnStyle
    }
];
const PositionDetails = ({ title, purchaseList, top3 = false, setModalConfirm, onClickViewAll }) => {
    const handleViewAll = () => {
        if (onClickViewAll) {
            onClickViewAll();
        }
    };
    let list = purchaseList;
    if (top3) {
        list = purchaseList.slice(0, 3);
    }
    const { isAllowed, isLoading } = useValidateUserActivity('STOCK_TRADING');
    const listTable = list.map((record, key) => {
        var _a;
        const changePercent = ((_a = record === null || record === void 0 ? void 0 : record.stockData) === null || _a === void 0 ? void 0 : _a.regularMarketChangePercent) || 0;
        return {
            id: key,
            name: (React.createElement("div", { className: Styles.nameC },
                React.createElement("div", { className: Styles.text1 }, record === null || record === void 0 ? void 0 : record.stockName),
                React.createElement("div", { className: Styles.text2 }, record === null || record === void 0 ? void 0 : record.stockId))),
            change: (React.createElement("div", { className: Styles.changeC },
                React.createElement("span", { className: changePercent >= 0 ? Styles.green : Styles.red },
                    changePercent >= 0 && '+',
                    " ",
                    parsePercent(changePercent),
                    "%"))),
            price: (React.createElement("div", { className: Styles.nameC },
                React.createElement("div", { className: Styles.text1 }, parseNumberMoney(record === null || record === void 0 ? void 0 : record.customPrice)),
                React.createElement("div", { className: Styles.text2 }, "Per share"))),
            marketValue: (React.createElement("div", { className: Styles.nameC },
                React.createElement("div", { className: Styles.text1 }, parseNumberMoney(record === null || record === void 0 ? void 0 : record.customAmount)),
                React.createElement("div", { className: Styles.text2 },
                    "Quantity: ", record === null || record === void 0 ? void 0 :
                    record.customQuantity)))
        };
    });
    return (React.createElement("div", { className: Styles.detailsContainer },
        React.createElement("h3", { className: Styles.title },
            title,
            top3 && (React.createElement("span", { className: Styles.viewAll, onClick: handleViewAll }, 'View All ->'))),
        React.createElement("br", null),
        React.createElement(CustomBootstrapTable, { keyField: "id", data: listTable, columns: columns, disablePagination: top3 }),
        setModalConfirm && top3 && (React.createElement(ButtonKVBase, { onClick: () => setModalConfirm(true), type: "button", rightIcon: React.createElement(IconActivity, { color: "white" }), btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", disabled: isLoading || !isAllowed }, 'Start Trading'))));
};
export default PositionDetails;
